module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "list-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "playlist",
    on: {
      "click": _vm.hide
    }
  }, [_c('div', {
    staticClass: "list-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "list-header"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.iconMode,
    on: {
      "click": _vm.changeMode
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.modeText))]), _vm._v(" "), _c('span', {
    staticClass: "clear",
    on: {
      "click": _vm.showConfirm
    }
  }, [_c('i', {
    staticClass: "icon-clear"
  })])])]), _vm._v(" "), _c('scroll', {
    ref: "listContent",
    staticClass: "list-content",
    attrs: {
      "data": _vm.sequenceList,
      "refreshDelay": _vm.refreshDelay
    }
  }, [_c('transition-group', {
    ref: "list",
    attrs: {
      "name": "list",
      "tag": "ul"
    }
  }, _vm._l((_vm.sequenceList), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectItem(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "current",
      class: _vm.getCurrentIcon(item)
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "like",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleFavorite(item)
        }
      }
    }, [_c('i', {
      class: _vm.getFavoriteIcon(item)
    })]), _vm._v(" "), _c('span', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteOne(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon-delete"
    })])])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "list-operate"
  }, [_c('div', {
    staticClass: "add",
    on: {
      "click": _vm.addSong
    }
  }, [_c('i', {
    staticClass: "icon-add"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("添加歌曲到队列")])])]), _vm._v(" "), _c('div', {
    staticClass: "list-close",
    on: {
      "click": _vm.hide
    }
  }, [_c('span', [_vm._v("关闭")])])], 1), _vm._v(" "), _c('confirm', {
    ref: "confirm",
    attrs: {
      "text": "是否清空播放列表",
      "confirmBtnText": "清空"
    },
    on: {
      "confirm": _vm.confirmClear
    }
  }), _vm._v(" "), _c('add-song', {
    ref: "addSong"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-007bfa40","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/playlist/playlist.vue
// module id = 528
// module chunks = 9